import React from 'react'

const Rectangle = ({width="22",height="6"}) => (
    <svg width={width} height={height} viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="22" height="5" fill="#F96E46"/>
    </svg>

)

export default Rectangle